<template>
  <div
    v-if="
      auth.user.selectedAccess.roleLevel > 3 ||
      (distributor && auth.user.selectedAccess.distributor_id == distributor.id)
    "
  >
    <loading-spinner v-if="!distributor" />
    <app-header
      v-if="distributor"
      :title="distributor.name"
      :subtitle="`${getLabel('DISTRIBUTOR')} #${distributor.id}`"
    >
      <template #col-right>
        <div
          v-if="
            auth.user.selectedAccess.roleLevel >= 3 &&
            auth.user.selectedAccess.can_modify_settings
          "
        >
          <b-button
            v-router-link="{
              name: 'distributor-editor',
              query: { id: $route.params.id },
            }"
            variant="primary"
          >
            <i class="fa fa-pencil-square-o" style="font-size: 20px" />&nbsp;
            <span v-label-key="'EDIT_DISTRIBUTOR'">Edit Distributor</span>
          </b-button>
        </div>
      </template>
    </app-header>

    <b-container>
      <b-nav tabs class="mb-3">
        <b-nav-item :to="{ name: 'distributor-reports-tab' }">
          <span v-label-key="'REPORTS'">Reports</span>
        </b-nav-item>
        <b-nav-item :to="{ name: 'distributor-transactions-tab' }">
          <span v-label-key="'TRANSACTIONS'">Transactions</span>
        </b-nav-item>
        <b-nav-item :to="{ name: 'distributor-subdistributors-tab' }">
          <span v-label-key="'SUBDISTRIBUTORS'">Subdistributors</span>
          ({{ summary?.subdistributorCount || 0 }})
        </b-nav-item>
        <b-nav-item :to="{ name: 'distributor-chains-tab' }">
          <span v-label-key="'CHAINS'">Chains</span>
          ({{ summary?.chainCount || 0 }})
        </b-nav-item>
        <b-nav-item :to="{ name: 'distributor-stores-tab' }">
          <span v-label-key="'STORES'">Stores</span> ({{
            summary?.storeCount || 0
          }})
        </b-nav-item>
        <b-nav-item :to="{ name: 'distributor-users-tab' }">
          <span v-label-key="'USERS'">Users</span> ({{
            summary?.userCount || 0
          }})
        </b-nav-item>
        <b-nav-item :to="{ name: 'distributor-screensavers-list-tab' }">
          <span v-label-key="'SCREENSAVERS'">Screensavers</span>
        </b-nav-item>
        <b-nav-item
          v-if="
            auth.user.selectedAccess.roleLevel > 3 &&
            getShowTab('warranty_settings')
          "
          :to="{ name: 'distributor-extended-warranty-tab' }"
        >
          <span v-label-key="'WARRANY_SETTINGS'">Warranty Settings</span>
        </b-nav-item>
        <b-nav-item
          v-if="getShowTab('lifetime_warranty')"
          :to="{ name: 'distributor-lifetime-warranty-tab' }"
        >
          <span v-label-key="'LIFETIME_WARRANTY'">Lifetime Warranty</span>
        </b-nav-item>
        <b-nav-item :to="{ name: 'distributor-about-tab' }">
          <span v-label-key="'ABOUT'">About</span>
        </b-nav-item>

        <b-nav-item
          v-if="auth.user.selectedAccess.roleLevel > 3"
          :to="{ name: 'distributor-template-types-tab' }"
        >
          <span v-label-key="'TEMPLATE_TYPES'">Template Types</span>
        </b-nav-item>

        <b-nav-item
          v-if="auth.user.selectedAccess.roleLevel > 3"
          :to="{ name: 'distributor-email-templates-tab' }"
        >
          <span v-label-key="'EMAIL_TEMPLATES'">Email Templates</span>
        </b-nav-item>

        <b-nav-item
          v-if="auth.user.selectedAccess.roleLevel > 3"
          :to="{ name: 'distributor-settings-tab' }"
        >
          <span v-label-key="'CHAIN_SETTINGS'">Chain Settings</span>
        </b-nav-item>
        <b-nav-item
          v-if="auth.user.selectedAccess.roleLevel > 3"
          :to="{ name: 'distributor-store-settings-tab' }"
        >
          <span v-label-key="'STORE_SETTINGS'">Store Settings</span>
        </b-nav-item>
        <b-nav-item
          v-if="auth.user.selectedAccess.can_manage_staff"
          :to="{ name: 'distributor-staff-tab' }"
        >
          <span v-label-key="'STAFF'">Staff</span> ({{
            summary?.retailStaffCount || 0
          }})
        </b-nav-item>
      </b-nav>
      <div>
        <router-view :distributor_id="$route.params.id" />
      </div>
    </b-container>
  </div>
</template>

<script>
import $auth from "@/services/auth";
import $api from "@/services/api";

import { mapGetters } from "vuex";

import LoadingSpinner from "@/components/LoadingSpinner";
import AppHeader from "@/components/AppHeader";

export default {
  components: {
    LoadingSpinner,
    AppHeader,
  },
  data() {
    return {
      auth: $auth,
      distributor: [],
      summary: null,
    };
  },
  computed: {
    ...mapGetters("config", ["getShowTab"]),
    ...mapGetters("translations", {
      getLabel: "getLabel",
    }),
  },
  created() {
    this.refreshData();
  },
  methods: {
    refreshData() {
      this.$store.commit("global/clearAllState");

      $api
        .get(`/v1/dashboard/distributors/${this.$route.params.id}`)
        .then((distributor) => {
          this.distributor = distributor;
        });

      $api
        .get(`/v1/dashboard/distributors/summary?distributor_id=${this.$route.params.id}`)
        .then((response) => {
          this.summary = response;
        });

      // this.$store.dispatch('global/getSubdistributorsList', {
      //   distributor_id: this.$route.params.id,
      // });
      // this.$store.dispatch('global/getChains', {
      //   distributor_id: this.$route.params.id,
      // });
      // this.$store.dispatch('global/getStores', {
      //   distributor_id: this.$route.params.id,
      // });
      // this.$store.dispatch('global/getUsers', {
      //   distributor_id: this.$route.params.id,
      // });
    },
  },
};
</script>
<style scoped>
a {
  color: black;
}
</style>
